class CartOrderBump extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('change', this.onChange.bind(this));
  }

  get variantSelect() {
    return this.querySelector('.cart-order-bump__variant-select');
  }

  get planSelect() {
    return this.querySelector('.cart-order-bump__plan-select');
  }

  get variantId() {
    return this.variantSelect ? this.variantSelect.value : this.dataset.defaultVariant;
  }

  get sellingPlan() {
    return this.planSelect ? this.planSelect.value : '';
  }

  onChange(event) {
    if (!event.target.matches('.cart-order-bump__variant-select')) return;
    const option = event.target.selectedOptions[0];
    if (!option) return;

    const priceEl = this.querySelector('.cart-order-bump__price');
    const compareEl = this.querySelector('.cart-order-bump__compare');
    if (priceEl && option.dataset.price) priceEl.textContent = option.dataset.price;
    if (compareEl) {
      if (option.dataset.hasCompare === 'true' && option.dataset.compare) {
        compareEl.textContent = option.dataset.compare;
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }
  }

  onClick(event) {
    const button = event.target.closest('.cart-order-bump__add');
    if (!button) return;
    event.preventDefault();
    this.add(button);
  }

  add(button) {
    const id = this.variantId;
    if (!id) return;

    button.setAttribute('disabled', 'disabled');
    button.classList.add('is-loading');

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    const lineItem = { id: Number(id), quantity: 1 };
    const plan = this.sellingPlan;
    if (plan) lineItem.selling_plan = Number(plan);

    const body = JSON.stringify({
      items: [lineItem],
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname,
    });

    fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body,
    })
      .then((response) => response.json())
      .then((state) => {
        if (state.status) {
          button.removeAttribute('disabled');
          button.classList.remove('is-loading');
          return;
        }
        this.renderSections(state);
      })
      .catch(() => {
        button.removeAttribute('disabled');
        button.classList.remove('is-loading');
      });
  }

  renderSections(state) {
    if (!state.sections) return;

    const parser = new DOMParser();
    const getInner = (html, selector) => {
      const node = parser.parseFromString(html, 'text/html').querySelector(selector);
      return node ? node.innerHTML : '';
    };

    if (state.sections['cart-drawer']) {
      const drawerContent = document.querySelector('#CartDrawer');
      if (drawerContent) {
        drawerContent.innerHTML = getInner(state.sections['cart-drawer'], '#CartDrawer');
      }
    }

    if (state.sections['cart-icon-bubble']) {
      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble) {
        bubble.innerHTML = getInner(state.sections['cart-icon-bubble'], '.shopify-section');
      }
    }

    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    const overlay = drawer.querySelector('#CartDrawer-Overlay');
    if (overlay && typeof drawer.close === 'function') {
      overlay.addEventListener('click', drawer.close.bind(drawer));
    }
    drawer.classList.add('active');
    const inner = drawer.querySelector('.drawer__inner');
    if (inner) inner.classList.remove('is-empty');
  }
}

if (!customElements.get('cart-order-bump')) {
  customElements.define('cart-order-bump', CartOrderBump);
}
